window.addEventListener("DOMContentLoaded", () => {
	let longtexts = document.querySelectorAll(".longtext");
	if (longtexts) {
		longtexts.forEach((el) => {
			let more = el.querySelector(".more:not(.less)");
			let less = el.querySelector(".less");
			if (more && less) {
				more.addEventListener("click", () => {
					el.classList.toggle("reduce");
				});
				less.addEventListener("click", () => {
					el.classList.toggle("reduce");
				});
			}

			el.classList.add("reduce");
		});
	}
});
